import { get } from "http";

export const API_URL =
  process.env.REACT_APP_API_URL || "https://ozriapi.appgrowthcompany.com";
export const SOCKET_URL = "https://ozriapi.appgrowthcompany.com";

export const END_POINTS = {
  login: "admin/login/",
  upload: "upload-file/",
  get_user: "/me/",
  profile: "profile/update/",
  logout: "logout/",
  // forgotPassword: "admin/forgot-password/",
  forgotPassword: "admin/forgot-password/",
  // verifyOtp: "admin/reset-password",
  verifyOtp: "/verify-otp/",
  resetPassword: "/reset-password/",
  changePassword: "/change-password/",
  uploadMedia: "upload-file/",

  // CMS Endpoints
  getCms: "/cms/detail/",
  updateCms: "/admin/cms/",
  getFaq: "/faq/list/",
  addFaq: "/admin/faq/create/",
  detailFaq: "/admin/faq/detail",
  updateFaq: "/admin/faq/update",
  deleteFaq: "/faq/delete",

  // User Endpoints
  users: "/manage-user/",
  updateUser: "/manage-user/update/",
  deleteUser: "/manage-user/delete/",
  userTasks: "/manage-user/tasks/",
  userExpense: "manage-user/expenses/",

  // ai moods
  moods: "ai-mood/",
  updateMoods: "ai-mood/update/",
  deleteMoods: "ai-mood/delete/",

  //labels
  addLabel: "admin/label/create/",
  getLabel: "admin/label/",
  deleteLabel: "admin/label/delete/",

  // shopping meal
  addCategory: "admin/categories/create/",
  getCategory: "admin/categories/listing/",
  deleteCategory: "admin/categories/delete/",
  getCategoryById: "admin/categories/detail",
  updateCategory: "admin/categories/create/",
  addSubCategory: "admin/subcategories/create/",
  getSubCategory: "admin/subcategories/listing/",
  getSubCategoryById: "admin/subcategories/detail",
  updateSubCategory: "admin/subcategories/create/",
  deleteSubCategory: "admin/subcategories/delete/",

  // hydration & goal
  addHydration: "admin/addupdate/hydration/",
  getHydration: "admin/hydration/list/",
  getHydrationById: "admin/hydration/",
  deleteHydration: "admin/hydration/delete/",

  //Remainder
  addRemainder: "admin/addupdate/reminder/",
  getRemainder: "admin/reminder/list/",
  getRemainderById: "admin/reminder/",
  deleteRemainder: "admin/reminder/delete/",

  // Customer Support
  getCustomerSupport: "admin/customer-support/",
  getCustomerSupportById: "admin/customer-support/details/",
  updateCustomerSupport: "admin/customer-support/revert/",
  deleteCustomerSupport: "admin/customer-support/delete/",

  // Sub Admin
  addSubAdmin: "admin/subadmin/create/",
  getSubAdmin: "admin/subadmin/list/",
  getSubAdminById: "admin/subadmin/detail/",
  updateSubAdmin: "admin/subadmin/update/",
  deleteSubAdmin: "admin/subadmin/delete/",
  updateStatus: "admin/subadmin/status/",

  // Role
  addRole: "admin/role-module/create-update/",
  getRole: "admin/role-module/list/",
  getRoleById: "admin/role-module/detail/",
  deleteRole: "admin/role-module/delete/",

  //modules
  getModules: "admin/module/detail/",
  addModules: "admin/module/create/",

  // Doc OCR
  docOCR: "admin/docs-ocr/create/update/",
  updateOCR: "admin/docs-ocr/create/update/",
  getOCR: "admin/docs-ocr/list/",
  getOCRById: "admin/docs-ocr/",
  deleteOCR: "admin/docs-ocr/delete/",

  //multilingualEngine
  multilingual: "ai-multilingual/",

  //GioLoaction
  location: "admin/geo-location/",
  addLoaction: "admin/geo-location/create/",
  locationById: "admin/geo-location/",
  updateLoaction: "admin/geo-location/update/",
  deleteLoaction: "admin/geo-location/delete/",

  //Subscription
  subscriptionList: "/subscription-admin/",

  //Budget Inteligence Category
  budgetCategory: "/budget-inteligence-category",
  addBudgetCategory: "/create-budget-inteligence-category/",
  updateBugde: "/budget-inteligence-category/update/",
  deleteBugde: "/budget-inteligence-category/delete/",
  getByIdBugde: "/budget-inteligence-category/",

  //Ai voice
  aiVoice: "/ai-voice-lib/",
  aiVoiceupdate: "/ai-voice-lib/update/",
  addVoice: "/create-ai-voice-lib/",
  deleteVoice: "/ai-voice-lib/delete/",
  getByIdVoice: "/ai-voice-lib/",

  //settings
  addAge: "create-setting-age-group/",
  updateAge: "setting-age-group/update/",
  getAge: "setting-age-group/",
  getAgeById: "setting-age-group/",
  deleteAge: "setting-age-group/delete/",
  //Template
  addTemplate: "create-settings-template/",
  getTemplate: "settings-template/",
  updateTemplate: "settings-template/update/",
  deleteTemplate: "settings-template/delete/",
  getTemplateById: "settings-template/",

  //Revenue
  revenue: "revenue-history/",
  //Alert Configration
  addAlert: "create-budget-inteligence-alert/",
  updateAlert: "budget-inteligence-alert/update/",
  getAlert: "budget-inteligence-alert/",
  deleteAlert: "budget-inteligence-alert/delete/",
  getAlertById: "budget-inteligence-alert/",

  //Tone Config
  addTone: "create-budget-inteligence-tone/",
  updateTone: "budget-inteligence-tone/update/",
  getTone: "budget-inteligence-tone/",
  deleteTone: "budget-inteligence-tone/delete/",
  getToneById: "budget-inteligence-tone/",

  // Notification
  addNotification: "admin/notification/create/",
  updateNotification: "admin/notification/update/",
  getNotifications: "admin/notification/",
  getByIdNotification: "admin/notification/",
  deleteNotification: "admin/notification/delete/",

  // rest password
  getPassword: "manage-user-password/",
  updatePassword: "manage-user-password/update/",
  getByIdPassword: "/manage-user-password/",

  //Family / Shared Account Manager
  getFamily: "shared-account/",
  getFamilyById: "shared-account/",
  updateFamily: "shared-account/update/",
  deleteFamily: "shared-account-delete/",
  unlinkFamily: "shared-account/delete/",
};
